import React, { useState, useEffect, useContext, useCallback } from "react";
import { Button, Table, Space, Dropdown, notification, Tooltip, Modal } from "antd";
import { DeleteOutlined, EditOutlined, DownOutlined, PaperClipOutlined } from "@ant-design/icons";
import MeetingPointsDetailsForm from "../components/Forms/MeetingPointsDetailsForm";
import MeetingForm from "../components/Forms/MeetingForm";
import axios from "axios";
import GlobalContext from "../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import MessageDialog from "../components/MessageDialog";
import LoadingModal from "../utils/LoadingModal";
import { useParams } from "react-router-dom";
import MeetingNewPointsForm from "../components/Forms/MeetingNewPointsForm";
import AddMeetingPointsTable from "../pages/AddMeetingPointsTable";
import MeetingInformation from "../components/MeetingInformation";
import { MEETING_STATUS } from "../utils/Constants";
import { useNavigate } from 'react-router-dom';

const PAGE_SIZE = 15;

const MeetingDetails = () => {
  const navigate = useNavigate();
  const globals = useContext(GlobalContext);
  const userEmail = globals.userEmail;
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });

  //En data estan los puntos estandars y dataNewPoints 
  //estan los puntos nuevos ***********************************
  const [dataActionPoints, setDataActionPoints] = useState([]);
  const [dataDecisionPoints, setDataDecisionPoints] = useState([]);
  const [dataStandardPoints, setDataStandardPoints] = useState([]);
  const [dataReschedulePoints, setDataReschedulePoints] = useState([]);
  const [dataNewPoints, setDataNewPoints] = useState([]);
  //***********************************************************

  //Para editar la meeting ****************************************
  //templates
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [isEditMeeting, setIsEditMeeting] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  //************************************************************

  //Punto nuevo de reunion para editar **************************
  const [currentMeetingNewPoint, setCurrentMeetingNewPoint] = useState(null);

  const [showCreateMeetingNewPoints, setShowCreateMeetingNewPoint] = useState(false);
  const [showAddMeetingPoints, setShowAddMeetingPoints] = useState(false);
  const [showMeetingPointsForm, setShowMeetingPointsForm] = useState(false);

  //****************************************
  const [isEditStandardPoint, setIsEditStandardPoint] = useState(false);
  const [isEditNewPoint, setIsEditNewPoint] = useState(false);
  const [currentPointDetails, setCurrentPointDetails] = useState(null);
  const [messageVisible, setMessageVisible] = useState(false);
  // const [details, setDetails] = useState([]);
  const { id } = useParams();

  const columns = [
    {
      title: "Nombre del punto",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (_, record) => (
        <Tooltip title={record.description}>
          <span>{record.name}</span>
        </Tooltip>
      ),
    },
    {
      title: "Doc. Ref",
      dataIndex: "docref",
      key: "docref",
      width: 75,
      render: (_, record) => {
        if (record?.attach_files?.length > 0) {
          const menuAttachments = {
            items: [],
            onClick: ({ key }) => {
              window.open(key, "_blank");
            }
          }
          for (const file of record.attach_files) {
            const item = {
              key: file.url,  
              label: file.name,
              icon: <PaperClipOutlined />,
            }
            menuAttachments.items.push(item);
            
          };
          return (
            <Dropdown menu={menuAttachments}>
              <Button icon={<PaperClipOutlined />} shape="circle" />
            </Dropdown>
          )
        }
        return (
          <span></span>
        )
      },
    },
    {
      title: "Tipo de punto",
      dataIndex: "point_type_name",
      key: "point_type",
    },
    {
      title: "Clasificación",
      dataIndex: ["classification", "name"],
      key: "classification",
    },
    {
      title: "Responsable",
      dataIndex: "responsible",
      key: "responsible",
      render: (_, record) => {
        return record.responsible ? record.responsible : 
        <Button
          onClick={() => handleEditResponsible(record)}
        >
          Asignar a mí
        </Button>
      }
    },
    {
      title: "🕑",
      dataIndex: "duration",
      key: "duration",
      // width: 50,
      render: (text) => {
        return (text) ? `${text} min` : `0 min`;
      },
    },
    {
      title: "Opciones",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "1",
                  label: "Editar",
                  icon: <EditOutlined />,
                  onClick: () => handleActionClick("edit", record),
                },
                // {
                //   key: "2",
                //   label: "Eliminar",
                //   icon: <DeleteOutlined />,
                //   onClick: () => handleActionClick("delete", record),
                // },
              ],
            }}
          >
            <Button icon={<DownOutlined />} shape="circle" />
          </Dropdown>
        </Space>
      ),
    },
  ];
  const columnsNewPoints = [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (_, record) => (
        <Tooltip title={record.description}>
          <span>{record.name}</span>
        </Tooltip>
      ),
    },
    {
      title: "Doc. Ref",
      dataIndex: "docref",
      key: "docref",
      width: 75,
      render: (_, record) => {
        if (record?.attach_files?.length > 0) {
          const menuAttachments = {
            items: [],
            onClick: ({ key }) => {
              window.open(key, "_blank");
            }
          }
          for (const file of record.attach_files) {
            const item = {
              key: file.url,  
              label: file.name,
              icon: <PaperClipOutlined />,
            }
            menuAttachments.items.push(item);
            
          };
          return (
            <Dropdown menu={menuAttachments}>
              <Button icon={<PaperClipOutlined />} shape="circle" />
            </Dropdown>
          )
        }
        return (
          <span></span>
        )
      },
    },
    // {
    //   title: "Tipo de reunión",
    //   dataIndex: "meeting_type_name",
    //   key: "meeting_type",
    // },
    // {
    //   title: "Departamento",
    //   dataIndex: "department_name",
    //   key: "department",
    // },
    // {
    //   title: "Tipo de punto",
    //   dataIndex: "point_type_name",
    //   key: "point_type",
    // },
    {
      title: "Clasificación",
      dataIndex: ["classification", "name"],
      key: "classification",
    },
    {
      title: "Responsable",
      dataIndex: "responsible",
      key: "responsible",
    },
    {
      title: "🕑",
      dataIndex: "duration",
      key: "duration",
      // width: 50,
      render: (text) => {
        return (text) ? `${text} min` : `0 min`;
      },
    },
    {
      title: "Opciones",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "1",
                  label: "Editar",
                  icon: <EditOutlined />,
                  onClick: () => handleActionClick("editNewPoint", record),
                },
                {
                  key: "2",
                  label: "Eliminar",
                  icon: <DeleteOutlined />,
                  onClick: () => handleActionClick("deleteNewPoint", record),
                },
              ],
            }}
          >
            <Button icon={<DownOutlined />} shape="circle" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const fetchDecisionData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
              pointTypesId: 4,
            },
          }
        );
        console.log("decisionPoints", response?.data?.data.rows);
        setDataDecisionPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          setDataReschedulePoints([]);
        } else {
          notification.error({
            message: "Error obteniendo puntos de decisión!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );
  const fetchActionData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
              pointTypesId: 5,
            },
          }
        );
        console.log("actionPoints", response?.data?.data.rows);
        setDataActionPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          setDataReschedulePoints([]);
        } else {
          notification.error({
            message: "Error obteniendo puntos de acción!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );
  const fetchRescheduleData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
              pointTypesId: 3,
            },
          }
        );
        console.log("reschedulePoints", response?.data?.data.rows);
        setDataReschedulePoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          setDataReschedulePoints([]);
        } else {
          notification.error({
            message: "Error obteniendo puntos reagendados!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );
  const fetchData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
              pointTypesId: 1,
            },
          }
        );
        console.log("standardPoints", response?.data?.data.rows);
        setDataStandardPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          setDataStandardPoints([]);
        } else {
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );
  const fetchNewPointsData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-meeting-point-detail`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
              meetingId: id,
              pointTypesId: 2,
            },
          }
        );
        console.log("newPoints", response?.data?.data.rows.length);
        setDataNewPoints(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -1) {
          // notification.warning({
          //   message: "No hay información disponible!",
          //   placement: "bottomRight",
          //   duration: 2,
          // });
          setDataNewPoints([]);
        } else {
          notification.error({
            message: "Error obteniendo puntos nuevos!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  const fetchCurrentData = useCallback(
    async () => {
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/consult-meeting/${id}`,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        console.log("currentMeeting:", response);
        setCurrentMeeting(response?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -2) {
          notification.warning({
            message: "No hay información disponible!",
            placement: "bottomRight",
          });
          setDataStandardPoints([]);
        } else {
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchCurrentData();
    fetchData(null);
    fetchNewPointsData(null);
    fetchRescheduleData(null);
    fetchActionData(null)
    fetchDecisionData(null)
  }, [fetchData, fetchCurrentData, fetchNewPointsData, fetchRescheduleData, fetchActionData, fetchDecisionData]);

  const handleExecuteMeeting = async () => {
    const isOwner = currentMeeting.creator === userEmail;
    const isCohost = currentMeeting.co_host === userEmail;
    const isAdmin = globals.userRole === "admin";

    if (!isOwner && !isCohost && !isAdmin) {
      notification.warning({
        message: "No tienes permisos para ejecutar la reunión",
        placement: "bottomRight",
        duration: 3,
      });
      return;
    }

    if (currentMeeting.statusId === MEETING_STATUS.CANCELADA || currentMeeting.statusId === MEETING_STATUS.FINALIZADA) {
      notification.warning({
        message: "No puedes ejecutar una reunión finalizada o cancelada",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    Modal.confirm({
      title: 'Ejecutar reunión',
      content: '¿Seguro que desea ejecutar la reunión?',
      okText: 'Ejecutar',
      cancelText: 'Cancelar',
      async onOk() {
        runExecuteMeeting(currentMeeting);
      },
    });
  }

  const runExecuteMeeting = async () => {
    try{
      await axios.put(`${globals.SERVICE_API_DB}/v1/update-meeting-status-to-execution/${currentMeeting.id}`,
      null,
      {
        headers: {
          "x-token": globals.token,
        },
      });
    }
    catch(err){
      console.log(err?.response.data);
      let message = "Error ejecutando reunión";
      if (err?.response.data.status === -2){
        message = "No puedes ejecutar la reunión si hay una reunión anterior abierta o en ejecución";
      }
      else if (err?.response.data.status === -4){
        message = "No puedes ejecutar la reunión si hay puntos de reunión sin responsables asignados";
      }
      notification.warning({
        message: message,
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    window.history.pushState(null, "", `/meetings`);
    navigate(`/meeting/${currentMeeting.id}/execute`);
  }

  const handleEditMeeting = () => {

    // if (moment(currentMeeting.startDate).isBefore(moment())) {
    //   notification.warning({
    //     message: "No puedes editar reuniones pasadas",
    //     placement: "bottomRight",
    //     duration: 2,
    //   });
    //   return;
    // }
    if (currentMeeting.statusId === MEETING_STATUS.FINALIZADA || currentMeeting.statusId === MEETING_STATUS.CANCELADA) {
      notification.warning({
        message: "No puedes editar reuniones cerradas o canceladas",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    setIsEditMeeting(true);
    setShowMeetingForm(true);
  };

  const handleActionClick = async (key, record) => {
    if (key === "edit") {
      if (currentMeeting.statusId === MEETING_STATUS.ABIERTA){
        setIsEditStandardPoint(true);
        setCurrentPointDetails(record);
        setShowMeetingPointsForm(true);
      }
      else {
        notification.warning({
          message: "No puedes editar puntos de reunión en una reunión cerrada o cancelada",
          placement: "bottomRight",
          duration: 2,
        });
      }
    } else if (key === "delete") {
      setCurrentPointDetails(record);
      setMessageVisible(true);
    } else if (key === "editNewPoint") {
      setIsEditNewPoint(true);
      setCurrentMeetingNewPoint(record);
      setShowCreateMeetingNewPoint(true);
    } else if (key === "deleteNewPoint") {
      setCurrentMeetingNewPoint(record);
      setMessageVisible(true);
    }
  };

  async function handleTableChange(newPagination) {
    fetchData(newPagination);
  }

  const saveMeetingPointForm = async ({ status, newMeetingPoint }) => {
    setShowMeetingPointsForm(false);
    if (isEditStandardPoint) {
      setIsEditStandardPoint(false);
      notification.success({
        message: "Punto de reunión editado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    if (status === "created") {
      setDataStandardPoints([newMeetingPoint, ...dataStandardPoints]);
    }

    notification.success({
      message: "Punto de reunión creado exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });
  };

  const saveMeetingForm = async ({ status, newMeeting }) => {
    setShowMeetingForm(false);
    if (isEditMeeting) {
      notification.success({
        message: "Reunión editada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      setCurrentMeeting(newMeeting);
      return;
    }
  };

  const saveMeetingNewPointForm = async ({ status, newMeetingPoint }) => {
    setShowCreateMeetingNewPoint(false);
    setIsEditNewPoint(false);
    setCurrentMeetingNewPoint(null);
    if (status === "created") {
      setDataNewPoints([newMeetingPoint, ...dataNewPoints]);
      fetchCurrentData();
    }
    notification.success({
      message: "Punto de reunión creado exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });
  };

  const closeMeetingForm = () => {
    setShowMeetingForm(false);
  };

  const closeMeetingPointForm = () => {
    setShowMeetingPointsForm(false);
    setIsEditStandardPoint(false);
    setCurrentPointDetails(null);
  };

  const closeMeetingNewPointForm = () => {
    setShowCreateMeetingNewPoint(false);
    setIsEditNewPoint(false);
    setCurrentMeetingNewPoint(null);
  };

  const closeAddMeetingPointsTable = () => {
    setShowAddMeetingPoints(false);
    fetchData(null);
    fetchNewPointsData(null);
  };

  const deletePointDetails = async () => {
    setMessageVisible(false);
    try {
      await axios.delete(
        `${globals.SERVICE_API_DB}/v1/delete-meeting-point-detail/${currentPointDetails.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setDataStandardPoints(dataStandardPoints.filter((item) => item.id !== currentPointDetails.id));
      notification.success({
        message: "Punto de reunión estándar eliminado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    } catch (err) {
      console.log(err.response.data);
      notification.error({
        message: "Error eliminando punto estándar",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
  };

  const deleteNewPointDetails = async () => {
    setMessageVisible(false);
    try {
      await axios.delete(
        `${globals.SERVICE_API_DB}/v1/delete-meeting-point-detail/${currentMeetingNewPoint.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setDataNewPoints(dataNewPoints.filter((item) => item.id !== currentMeetingNewPoint.id));
      fetchCurrentData();
      notification.success({
        message: "Punto de reunión eliminado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    } catch (err) {
      console.log(err.response.data);
      notification.error({
        message: "Error eliminando punto de reunión!",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
  };

  const handleEditResponsible = async (record) => {
    try {
      // record.responsible = userEmail;
      const updatedRecord = { ...record, responsible: userEmail };
      const response = await axios.put(
        `${globals.SERVICE_API_DB}/v1/update-meeting-point-detail/${record.id}`,
        updatedRecord,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      if (response?.data?.status === 0) {
        setDataStandardPoints((prevPoints) =>
          prevPoints.map((item) =>
            item.id === record.id ? updatedRecord : item
          )
        );
        notification.success({
          message: "Responsable asignado exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error.response);
      notification.error({
        message: "Error asignando responsable",
        placement: "bottomRight",
      });
    }
  };

  const handleRefresh = () => {
    fetchCurrentData();
    fetchNewPointsData(null);
    fetchData(null);
    fetchRescheduleData(null);
    fetchActionData(null)
    fetchDecisionData(null)
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <Button
          onClick={() => {
            window.history.back();
          }}
          style={{ marginRight: "8px" }}
        >
          Regresar
        </Button>
        <h2 style={{ marginRight: "16px", display: "flex", alignItems: "center" }}>
          <span style={{ 
            fontWeight: "bold",
            fontSize: "24px",
            color: "#4096FF",
            display: "flex",
            alignItems: "center",
            marginRight: "8px",
          }}>Agenda:</span>
          <span>{currentMeeting?.title_meeting}</span>
        </h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        {(currentMeeting?.statusId === MEETING_STATUS.ABIERTA) && (
          <Button
            onClick={handleExecuteMeeting}
            style={{ marginRight: "8px" }}
            type="primary"
          >
            Ejecutar
          </Button>
        )}
        <Button
          onClick={handleEditMeeting}
          style={{ marginRight: "8px" }}
        >
          Editar
        </Button>
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <MeetingInformation meeting={currentMeeting} />
      {(dataDecisionPoints.length > 0) && (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <h4 style={{ marginBottom: 16 }}>Seguimiento de puntos de decisión</h4>
          <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        </div>
        <div
          className="site-layout-background h-auto"
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            margin: 0,
            height: "auto",
            overflow: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          <Table
            rowKey={(r) => uuidv4()}
            columns={columns}
            dataSource={dataDecisionPoints}
            pagination={pagination}
            onChange={handleTableChange}
            scroll={{ y: "max-content" }}
            size="small"
          />
        </div>
      </div>
      )}
      {(dataActionPoints.length > 0) && (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <h4 style={{ marginBottom: 16 }}>Seguimiento de puntos de acción</h4>
          <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        </div>
        <div
          className="site-layout-background h-auto"
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            margin: 0,
            height: "auto",
            overflow: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          <Table
            rowKey={(r) => uuidv4()}
            columns={columns}
            dataSource={dataActionPoints}
            pagination={pagination}
            onChange={handleTableChange}
            scroll={{ y: "max-content" }}
            size="small"
          />
        </div>
      </div>
      )}
      {(dataReschedulePoints.length > 0) && (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <h4 style={{ marginBottom: 16 }}>Puntos de reunión reagendados</h4>
          <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        </div>
        <div
          className="site-layout-background h-auto"
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            margin: 0,
            height: "auto",
            overflow: "auto",
            backgroundColor: "#ffffff",
          }}
        >
          <Table
            rowKey={(r) => uuidv4()}
            columns={columns}
            dataSource={dataReschedulePoints}
            pagination={pagination}
            onChange={handleTableChange}
            scroll={{ y: "max-content" }}
            size="small"
          />
        </div>
      </div>
      )}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
        <h4 style={{ marginBottom: 16 }}>Puntos de reunión estándar</h4>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
      </div>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={dataStandardPoints}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h4 style={{ marginBottom: 16 }}>Puntos de reunión nuevos</h4>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          type="primary"
          onClick={() => {
            if (currentMeeting?.statusId === MEETING_STATUS.ABIERTA) {
              setShowAddMeetingPoints(true);
            } else {
              notification.warning({
                message: "No puedes agregar puntos de reunión a una reunión cerrada o cancelada",
                placement: "bottomRight",
                duration: 2,
              });
            }
          }}
          style={{ marginRight: "8px" }}
        >
          Agregar
        </Button>
        <Button
          type="primary"
          onClick={() => {
            if (currentMeeting?.statusId === MEETING_STATUS.ABIERTA) {
              setShowCreateMeetingNewPoint(true);
            }
            else {
              notification.warning({
                message: "No puedes agregar puntos de reunión a una reunión cerrada o cancelada",
                placement: "bottomRight",
                duration: 2,
              });
            }
            
          }}
          style={{ marginRight: "8px" }}
        >
          Crear
        </Button>
      </div>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columnsNewPoints}
          dataSource={dataNewPoints}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />

      <MeetingPointsDetailsForm
        open={showMeetingPointsForm}
        onFinish={saveMeetingPointForm}
        onCancel={closeMeetingPointForm}
        isEdit={isEditStandardPoint}
        currentMeetingPoint={currentPointDetails}
      />

      <MeetingForm
        open={showMeetingForm}
        onFinish={saveMeetingForm}
        onCancel={closeMeetingForm}
        isEdit={isEditMeeting}
        currentMeeting={currentMeeting}
      />
      <MeetingNewPointsForm
        open={showCreateMeetingNewPoints}
        onFinish={saveMeetingNewPointForm}
        onCancel={closeMeetingNewPointForm}
        isEdit={isEditNewPoint}
        currentMeetingNewPoint={currentMeetingNewPoint}
        currentMeeting={currentMeeting}
      />
      <Modal
        open={showAddMeetingPoints}
        onCancel={closeAddMeetingPointsTable}
        footer={[
          <Button key="ok" type="primary" onClick={closeAddMeetingPointsTable}>
            Cerrar
          </Button>,
        ]}
        width={1000}
      >
        <AddMeetingPointsTable
          currentMeetingId={currentMeeting?.id}
          meeting_type_name={currentMeeting?.meeting_type_name}
          department_name={currentMeeting?.department_name}
        />
      </Modal>
      <MessageDialog
        visible={messageVisible}
        title="Está seguro de eliminar este punto de reunión?"
        message="Esta acción no se puede deshacer."
        onOk={deletePointDetails}
        onCancel={() => setMessageVisible(false)}
        confirm={true}
      />
      <MessageDialog
        visible={messageVisible}
        title="Está seguro de eliminar este punto de reunión?"
        message="Esta acción no se puede deshacer."
        onOk={deleteNewPointDetails}
        onCancel={() => setMessageVisible(false)}
        confirm={true}
      />
    </div>
  );
};

export default MeetingDetails;
